import React, { useEffect, useState } from "react"
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa"

import classes from "./Pill.module.scss"
import { Input } from "."

const Pill = props => {
  const { value, max, min = 0, onChange } = props

  const [input, setInput] = useState(value)

  const handlePlus = () => {
    const newValue = value + 1

    if (newValue > max) return

    setInput(newValue)
    onChange(newValue)
  }

  const handleMinus = () => {
    const newValue = value - 1

    if (newValue < min) return

    setInput(newValue)
    newValue >= 0 && onChange(newValue)
  }

  const handleChange = e => {
    if (Number(e.target.value) > max) return

    setInput(e.target.value)
  }

  const handleBlur = (e) => {
    const text = e.target.value

    onChange(Number(text))
  }

  useEffect(() => {
    setInput(value)
  }, [value])

  const showDeleteButton =
    (input === 1 || input === "") && min !== 1

  const plusDisabled =
    value + 1 > max

  const minusDisabled =
    value - 1 < min

  return (
    <div className={classes["container"]}>
      <button
        disabled={minusDisabled}
        className={classes["minus"]}
        onClick={handleMinus}
      >
        {showDeleteButton ? <FaTrash /> : <FaMinus />}
      </button>
      <Input
        min={0}
        type="number"
        numberType="int"
        className={classes["input"]}
        value={input}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <button
        disabled={plusDisabled}
        className={classes["plus"]}
        onClick={handlePlus}
      >
        <FaPlus />
      </button>
    </div>
  )
}

export default Pill
